import { createContext, useContext, type ReactElement, type ReactNode } from 'react';
import { type ApiClient } from '../api/client';
import { apiClient } from '../api/default-client';

const ApiClientContext = createContext<ApiClient | null>(null);

export interface ApiClientProviderProps {
  client: ApiClient;
  children: ReactNode;
}

export function ApiClientProvider({ client, children }: ApiClientProviderProps): ReactElement {
  return <ApiClientContext.Provider value={client}>{children}</ApiClientContext.Provider>;
}

/** Nearest provided client, else the default `apiClient`. */
export function useApiClient(): ApiClient {
  return useContext(ApiClientContext) ?? apiClient;
}
